import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class SwitchTab extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        tabSwitch: PropTypes.func,
    };

    state = {
        nav: this.props.content,
        type: this.props.content[0].tag,
    };

    onClick = tag => {
        const { type } = this.state;

        if (tag === type) return;
        this.setState({ type: tag });
        this.props.tabSwitch(tag);
    };

    render() {
        const { nav, type } = this.state;

        return (
            <div className={styles.nav}>
                <ul>
                    {nav.map(item => (
                        <li
                            key={item.tag}
                            className={type === item.tag ? styles.li_checked : ''}
                            onClick={() => this.onClick(item.tag)}>
                            <span className={type === item.tag ? styles.span_checked : ''}>{item.name}</span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(SwitchTab);
